export default __webpack_public_path__ + "static/media/SndLowerPAroundBump.76cdd171.mp3";